import {ElementType, ReactElement, ReactNode} from "react";
import classNames from "classnames";

import {Text} from "@pg-design/text-module";

import {BadgeVariants, BadgeVariantsUnionType} from "../utils/badge_variant";

import {badgeBaseStyle, labelStyle, preserveTextSizeStyle} from "./Badge.module.css";

interface IProps {
    as?: ElementType;
    children: ReactNode;
    className?: string;
    icon?: (props: {fill: string; className: string; size?: string}) => ReactElement;
    iconSize?: string;
    preserveTextSize?: boolean;
    strong?: boolean;
    variant?: BadgeVariantsUnionType;
}

export const Badge = (props: IProps) => {
    const {as, children, className, icon: Icon, iconSize = "1", preserveTextSize = false, strong = false, variant = BadgeVariants.LABEL_DEFAULT} = props;

    const Component = as || "span";
    const variantStyle = getBadgeVariantStyle(variant);
    const badgeBaseCN = classNames(badgeBaseStyle, preserveTextSize && preserveTextSizeStyle, className);

    return (
        <Component className={badgeBaseCN} style={variantStyle}>
            {Icon && <Icon fill="inherit" className={labelStyle} size={iconSize} />}
            <Text as={as} color="inherit" noWrap strong={strong} variant="info_txt_2">
                {children}
            </Text>
        </Component>
    );
};

const getBadgeVariantStyle = (variant: BadgeVariantsUnionType) => {
    switch (variant) {
        case BadgeVariants.LABEL_DEFAULT: {
            return {
                backgroundColor: "var(--colors-background-100)"
            };
        }
        case BadgeVariants.LABEL_BG2: {
            return {
                backgroundColor: "var(--colors-background-200)"
            };
        }
        case BadgeVariants.LABEL_BEIGE: {
            return {
                backgroundColor: "var(--colors-beige-subtle)"
            };
        }
        case BadgeVariants.LABEL_SUCCESS: {
            return {
                backgroundColor: "var(--colors-success)"
            };
        }
        case BadgeVariants.LABEL_SUBTLE_GREEN: {
            return {
                backgroundColor: "var(--colors-green-subtle)"
            };
        }
        case BadgeVariants.LABEL_INFO: {
            return {
                backgroundColor: "var(--colors-info)"
            };
        }
        case BadgeVariants.LABEL_WARNING: {
            return {
                backgroundColor: "var(--colors-warning)"
            };
        }
        case BadgeVariants.LABEL_HIGHLIGHT: {
            return {
                backgroundColor: "var(--colors-highlight)"
            };
        }
        case BadgeVariants.LABEL_PRIMARY: {
            return {
                backgroundColor: "var(--colors-primary)",
                color: "var(--button-primaryLabelColor)"
            };
        }
        case BadgeVariants.LABEL_SECONDARY: {
            return {
                backgroundColor: "var(--colors-secondary)",
                color: "white",
                fill: "white",
                "--text-local-color": "white"
            };
        }
        case BadgeVariants.LABEL_DANGER: {
            return {
                backgroundColor: "var(--colors-danger)",
                color: "white",
                fill: "white",
                "--text-local-color": "white"
            };
        }
    }
};
import {ElementType, ReactElement, ReactNode} from "react";
import classNames from "classnames";

import {Text} from "@pg-design/text-module";

import {BadgeVariants, BadgeVariantsUnionType} from "../utils/badge_variant";

import {badgeBaseStyle, labelStyle, preserveTextSizeStyle} from "./Badge.module.css";

interface IProps {
    as?: ElementType;
    children: ReactNode;
    className?: string;
    icon?: (props: {fill: string; className: string; size?: string}) => ReactElement;
    iconSize?: string;
    preserveTextSize?: boolean;
    strong?: boolean;
    variant?: BadgeVariantsUnionType;
}

export const Badge = (props: IProps) => {
    const {as, children, className, icon: Icon, iconSize = "1", preserveTextSize = false, strong = false, variant = BadgeVariants.LABEL_DEFAULT} = props;

    const Component = as || "span";
    const variantStyle = getBadgeVariantStyle(variant);
    const badgeBaseCN = classNames(badgeBaseStyle, preserveTextSize && preserveTextSizeStyle, className);

    return (
        <Component className={badgeBaseCN} style={variantStyle}>
            {Icon && <Icon fill="inherit" className={labelStyle} size={iconSize} />}
            <Text as={as} color="inherit" noWrap strong={strong} variant="info_txt_2">
                {children}
            </Text>
        </Component>
    );
};

const getBadgeVariantStyle = (variant: BadgeVariantsUnionType) => {
    switch (variant) {
        case BadgeVariants.LABEL_DEFAULT: {
            return {
                backgroundColor: "var(--colors-background-100)"
            };
        }
        case BadgeVariants.LABEL_BG2: {
            return {
                backgroundColor: "var(--colors-background-200)"
            };
        }
        case BadgeVariants.LABEL_BEIGE: {
            return {
                backgroundColor: "var(--colors-beige-subtle)"
            };
        }
        case BadgeVariants.LABEL_SUCCESS: {
            return {
                backgroundColor: "var(--colors-success)"
            };
        }
        case BadgeVariants.LABEL_SUBTLE_GREEN: {
            return {
                backgroundColor: "var(--colors-green-subtle)"
            };
        }
        case BadgeVariants.LABEL_INFO: {
            return {
                backgroundColor: "var(--colors-info)"
            };
        }
        case BadgeVariants.LABEL_WARNING: {
            return {
                backgroundColor: "var(--colors-warning)"
            };
        }
        case BadgeVariants.LABEL_HIGHLIGHT: {
            return {
                backgroundColor: "var(--colors-highlight)"
            };
        }
        case BadgeVariants.LABEL_PRIMARY: {
            return {
                backgroundColor: "var(--colors-primary)",
                color: "var(--button-primaryLabelColor)"
            };
        }
        case BadgeVariants.LABEL_SECONDARY: {
            return {
                backgroundColor: "var(--colors-secondary)",
                color: "white",
                fill: "white",
                "--text-local-color": "white"
            };
        }
        case BadgeVariants.LABEL_DANGER: {
            return {
                backgroundColor: "var(--colors-danger)",
                color: "white",
                fill: "white",
                "--text-local-color": "white"
            };
        }
    }
};
